module.exports = __webpack_public_path__ + "img/6.f7935db2.webp";